import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#formatBenchmarkAboutCopy();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #formatBenchmarkAboutCopy() {
    if (window.location.pathname !== '/pages/about-us') return;

    const paragraphs = Array.from(this.querySelectorAll('p'));
    const firstParagraph = paragraphs[0];

    if (firstParagraph) {
      firstParagraph.textContent =
        'We are a Sydney-based company helping hospitality, childcare, education, workplaces and club canteens source the supplies they need.';
    }

    const supportParagraph = paragraphs.find((paragraph) =>
      paragraph.textContent.includes('Because we are small, we offer')
    );

    if (supportParagraph) {
      supportParagraph.textContent = supportParagraph.textContent.replace(/^Because we are small,\s*we offer/, 'We offer');
    }

    const instagramParagraph = paragraphs.find((paragraph) => paragraph.textContent.includes('Instagram coming soon'));

    if (instagramParagraph) {
      instagramParagraph.innerHTML =
        'Follow us on Instagram at <a href="https://www.instagram.com/benchmarksuppliesco/" target="_blank" rel="noopener noreferrer">@benchmarksuppliesco</a>.';
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
